import React from "react";
import BlogPostThumbnailsContainer from "components/BlogPostThumbnailsContainer";

import * as styles from "./BlogTopPicks.module.less";

/**
 * @typedef {object} Props
 * @prop {readonly GatsbyTypes.BlogPostThumbnailFragment[]} posts
 * @prop {string} labelText
 *
 *
 * @param {Props} props
 */
export default function BlogTopPicks({ posts, labelText }) {
  return (
    <section className={styles.topPicks}>
      <fieldset className={styles.container}>
        <legend className={styles.label}>{labelText}</legend>
        <div className={styles.content}>
          <BlogPostThumbnailsContainer posts={posts} />
        </div>
      </fieldset>
    </section>
  );
}
